import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "200px auto",
    marginTop: 15,
    marginBottom: 15,
    alignItems: "center",
  },
}));
const TextField = ({ record, source, label, type }) => {
  return <Show record={record} source={source} label={label} type={type} />;
};

const Show = ({ record, source, label, type }) => {
  const classes = useStyles();

  let value = getSource(record, source);
  if (type === "phone") {
    value = value ? value.split("|")[0] : "";
  }

  if (type === "boolean") {
    return (
      <Box className={classes.container}>
        <Typography variant="h6">{label}</Typography>
        <Typography>{value ? "Yes" : "No"}</Typography>
      </Box>
    );
  }

  return (
    <Box className={classes.container}>
      <Typography variant="h6">{label}</Typography>
      <Typography>{value.toLocaleString()}</Typography>
    </Box>
  );
};

function getSource(obj, source) {
  const sources = source.split(".");
  if (sources.length === 1) return obj[source];

  return sources.reduce((total, src) => (total = total[src]), obj);
}
export default TextField;
